/// <amd-module name="Build/Admin/Agent/Stores/StoresHub" />
import { ActionsHub } from "Build/Admin/Agent/Actions/ActionsHub";
import { AddUserCapabilityPanelStore } from "Build/Admin/Agent/Stores/AddUserCapabilityPanelStore";
import { SelectionStore } from "Build/Admin/Agent/Stores/SelectionStore";
import { ConfirmationDialogStore } from "Build/Admin/Common/Stores/ConfirmationDialogStore";
import { JobStore } from "Build/Admin/Common/Stores/JobStore";
import { NotificationStore } from "Build/Admin/Common/Stores/NotificationStore";
import { ProjectStore } from "Build/Admin/Common/Stores/ProjectStore";
import { SignalRStore } from "Build/Admin/Common/Stores/SignalRStore";

export class StoresHub {
    public addUserCapabilityPanelStore: AddUserCapabilityPanelStore;
    public confirmationDialogStore: ConfirmationDialogStore<string>;
    public jobStore: JobStore;
    public notificationStore: NotificationStore;
    public projectStore: ProjectStore;
    public selectionStore: SelectionStore;
    public signalRStore: SignalRStore;

    constructor(actionsHub: ActionsHub) {
        this.addUserCapabilityPanelStore = new AddUserCapabilityPanelStore();
        actionsHub.showAddUserCapabilityPanel.addListener(this.addUserCapabilityPanelStore.showPanel);
        actionsHub.dismissAddUserCapabilityPanel.addListener(this.addUserCapabilityPanelStore.dismissPanel);

        this.confirmationDialogStore = new ConfirmationDialogStore<string>();
        actionsHub.confirmationDialogActions.showConfirmationDialog.addListener(this.confirmationDialogStore.showDialog);
        actionsHub.confirmationDialogActions.dismissConfirmationDialog.addListener(this.confirmationDialogStore.dismissDialog);

        this.jobStore = new JobStore();
        actionsHub.jobActions.jobsUpdated.addListener(this.jobStore.updateJobs);
        actionsHub.jobActions.jobUpdated.addListener(this.jobStore.updateJob);

        this.notificationStore = new NotificationStore();
        actionsHub.notificationActions.addNotification.addListener(this.notificationStore.addNotification);
        actionsHub.notificationActions.dismissNotification.addListener(this.notificationStore.dismissNotification);
        actionsHub.notificationActions.clearNotifications.addListener(this.notificationStore.clearNotifications);

        this.selectionStore = new SelectionStore();
        actionsHub.selectedAgentUpdated.addListener(this.selectionStore.updateSelectedAgent);
        actionsHub.selectedAgentQueueUpdated.addListener(this.selectionStore.updateSelectedAgentQueue);
        actionsHub.selectedAgentPoolUpdated.addListener(this.selectionStore.updateSelectedAgentPool);
        actionsHub.selectedTabUpdated.addListener(this.selectionStore.updateSelectedTab);

        this.projectStore = new ProjectStore();
        actionsHub.projectActions.projectsUpdated.addListener(this.projectStore.updateProjects);

        this.signalRStore = new SignalRStore();
        actionsHub.signalRActions.signalRStateUpdated.addListener(this.signalRStore.updateSignalRState);
    }
}
